module.exports = angular;


//////////////////
// WEBPACK FOOTER
// external "angular"
// module id = 5
// module chunks = 0